import { add, subtract, multiply, divide } from "lodash-es";
import * as globalApi from "../api/global";

function formatOffsetToHhMm(offsetInMins: any) {
  const operater = offsetInMins < 0 ? "%2B" : "-";
  const positiveMins = Math.abs(offsetInMins);

  let hours: any = Math.floor(positiveMins / 60);
  let mins: any = Math.floor(positiveMins - (hours * 3600) / 60);
  if (hours < 10) {
    hours = "0" + hours;
  }
  if (mins < 10) {
    mins = "0" + mins;
  }

  return operater + hours + ":" + mins;
}
export const handleFilterStr = (filtersParam: Array<any>) => {
  let filterStr = "";
  filtersParam.forEach((item: any, index: number) => {
    let valueStr = "";
    let exp = "";
    if (item.filterOp == "between") {
      const myLocalOffset = new Date().getTimezoneOffset();
      const offsetStr = formatOffsetToHhMm(myLocalOffset);
      const prevTimeStr = `${item.value[0]}T00:00:00${offsetStr}`;
      const nextTimeStr = `${item.value[1]}T23:59:59${offsetStr}`;
      console.log("prevTimeStr", prevTimeStr);
      console.log("nextTimeStr", nextTimeStr);
      exp = `${item.filterprop} ge '${prevTimeStr}' and ${item.filterprop} le '${nextTimeStr}'`;
    } else {
      if (item.filterOp == "in") {
        valueStr = `${encodeURI(item.value)}`;
      } else {
        valueStr = `'${item.value}'`;
      }
      exp = `${item.filterprop} ${item.filterOp} ${valueStr}`;
    }
    if (index === 0) {
      filterStr += exp;
    } else {
      filterStr += ` and ${exp}`;
    }
  });
  return filterStr;
};
export const handleDateRangeToSeconds = (DateRange: Array<any>) => {
  const myLocalOffset = new Date().getTimezoneOffset();
  const offsetStr = formatOffsetToHhMm(myLocalOffset);
  const prevTimeStr = `${DateRange[0]}T00:00:00${offsetStr}`;
  const nextTimeStr = `${DateRange[1]}T23:59:59${offsetStr}`;
  console.log("prevTimeStr", prevTimeStr);
  console.log("nextTimeStr", nextTimeStr);
  let prevMilliSeconds = Math.floor(new Date(prevTimeStr.replaceAll("%2B", "+")).getTime() / 1000);
  let nextMilliSeconds = Math.floor(new Date(nextTimeStr.replaceAll("%2B", "+")).getTime() / 1000);
  return [prevMilliSeconds, nextMilliSeconds];
};
export const handleBookingData = (data: any) => {
  const bookingData = data?.rows
    ?.map((row: any) => {
      let name = row.dimensionValues[0].value;
      let value = row.metricValues[0].value;
      if (["External API", "ALP Chassis"].includes(name)) {
        name = "Develop Portal";
      }
      return {
        name: name,
        value: value,
      };
    })
    .filter((i: any) => i.name !== null)
    .sort((a, b) => a.name.localeCompare(b.name));

  return bookingData;
};
export const handleConsIvcData = (data: any) => {
  // first count the total number from the row.metricValues[0].value
  const total = data?.rows?.reduce((acc: any, row: any) => {
    return acc + row.metricValues[0].value;
  }, 0);
  const ivcData = data?.rows
    ?.map((row: any) => {
      if (row.dimensionValues[0].value === true) {
        return {
          name: "To SAP",
          value: `${row.metricValues[0].value}`,
        };
      }
      // else skip, not in the return array
      else {
        return null;
      }
    })
    .filter((i: any) => i !== null);

  return [
    {
      name: "From CW1",
      value: `${total}`,
    },
    ...ivcData,
  ];
};
export const handleCustomerIvcData = (data: any) => {
  // first count the total number from the row.metricValues[0].value
  const total = data?.rows?.reduce((acc: any, row: any) => {
    return acc + row.metricValues[0].value;
  }, 0);
  const ivcData = data?.rows
    ?.map((row: any) => {
      if (row.dimensionValues[0].value === "DISPATCHED") {
        return {
          name: "To CW1",
          value: `${row.metricValues[0].value}`,
        };
      }
      // else skip, not in the return array
      else {
        return null;
      }
    })
    .filter((i: any) => i !== null);

  return [
    {
      name: "From SAP",
      value: `${total}`,
    },
    ...ivcData,
  ];
};
export const handleSuppilerIvcData = (data: any) => {
  // first count the total number from the row.metricValues[0].value
  const total = data?.rows?.reduce((acc: any, row: any) => {
    return acc + row.metricValues[0].value;
  }, 0);
  const ivcData = data?.rows
    ?.reduce((acc: any, row: any) => {
      if (
        row.dimensionValues[0].value === "DISPATCHED" ||
        row.dimensionValues[0].value === "CW1_PROCESSED"
      ) {
        const existing = acc.find((item: any) => item.name === "To CW1");
        if (existing) {
          existing.value += row.metricValues[0].value;
        } else {
          acc.push({
            name: "To CW1",
            value: row.metricValues[0].value,
          });
        }
      }
      return acc;
    }, [])
    .map((item: any) => ({
      ...item,
      value: `${item.value}`,
    }));

  return [
    {
      name: "From SAP",
      value: `${total}`,
    },
    ...ivcData,
  ];
};
export const handleLatencyData = (airData: any, lclData: any, isNotAll: boolean) => {
  try {
    let airName = airData?.cols?.[airData.cols.length - 1]?.name ?? "";
    let lclName = lclData?.cols?.[lclData.cols.length - 1]?.name ?? "";
    let airValue = airData?.rows?.[0]?.[airData.rows[0].length - 1] ?? "0%";
    let lclValue = lclData?.rows?.[0]?.[lclData.rows[0].length - 1] ?? "0%";
    if (!isNotAll) {
      let airRows = airData?.rows || [];
      let lclRows = lclData?.rows || [];

      if (airRows.length === 0 || lclRows.length === 0) {
        airValue = "0%";
        lclValue = "0%";
      } else {
        let airTotal = airRows.reduce((acc: any, row: any) => acc + row[2], 0);
        let airLatency = airRows.reduce((acc: any, row: any) => acc + row[3], 0);
        airValue = Number(divide(airLatency, airTotal)).toFixed(2) + "%";

        let lclTotal = lclRows.reduce((acc: any, row: any) => acc + row[2], 0);
        let lclLatency = lclRows.reduce((acc: any, row: any) => acc + row[3], 0);
        lclValue = Number(divide(lclLatency, lclTotal)).toFixed(2) + "%";
      }
    }
    return [
      {
        name: `Air ${airName}`,
        value: airValue,
      },
      {
        name: `LCL ${lclName}`,
        value: lclValue,
      },
    ];
  } catch (e) {
    console.log("handleLatencyData error", e);
    return [];
  }
};
export const handleSupportMetricData = (supportMetrics: any) => {
  try {
    let cols = supportMetrics?.data?.cols || [];
    let rows = supportMetrics?.data?.rows || [];
    let res: any = [];
    cols.forEach((col: any, index: number) => {
      let display_name = col.display_name;
      let value = rows[0]?.[index] ?? 0;
      res.push({
        name: display_name,
        value: value,
      });
    });
    return res;
  } catch (e) {
    console.log("handleLatencyData error", e);
    return [];
  }
};

export const handleCustomerInvLatencyData = (data: any) => {
  try {
    const cols = data?.data?.cols || [];
    const rows = data?.data?.rows || [];

    return rows.map((row: any[]) => {
      let obj: any = {};
      cols.forEach((col: any, index: number) => {
        obj[col.name] = row[index];
      });
      return obj;
    });
  } catch (e) {
    console.log("handleCustomerInvLatencyData error", e);
    return [];
  }
};
export const handleChartItem = (item: any, cols: any, card: any, data: any) => {
  const xAxis = card.dimensions[0].name;
  const xIndex = cols.findIndex((col: any) => col.name === xAxis);
  const xValue = item[xIndex];

  let typeValue = "";
  if (card.dimensions.length > 1) {
    const typeField = card.dimensions[1].name;
    const typeIndex = cols.findIndex((col: any) => col.name === typeField);
    typeValue = item[typeIndex];
  }

  card.metrics.forEach((metric: any) => {
    const yAxis = metric.name;
    const yIndex = cols.findIndex((col: any) => col.name === yAxis);
    let yValue = item[yIndex];

    if (typeof yValue === "number") {
      yValue = Number(yValue.toFixed(2));
    } else if (!isNaN(Number(yValue))) {
      yValue = Number(Number(yValue).toFixed(2));
    }

    const newObj = {
      id: xValue,
      count: yValue,
      type: typeValue || metric.displayName, // Use typeValue if available, otherwise use metric.displayName
    };

    data.push(newObj);
  });

  // Handle additional columns as metrics
  cols.forEach((col: any, index: number) => {
    if (
      !card.dimensions.some((dim: any) => dim.name === col.name) &&
      !card.metrics.some((metric: any) => metric.name === col.name)
    ) {
      let yValue = item[index];

      if (typeof yValue === "number") {
        yValue = Number(yValue.toFixed(2));
      } else if (!isNaN(Number(yValue))) {
        yValue = Number(Number(yValue).toFixed(2));
      }

      const newObj = {
        id: xValue,
        count: yValue,
        type: col.display_name,
      };

      data.push(newObj);
    }
  });
};

export const handleDownloadAttachment = async (
  attachmentId: string,
  getFileUrl: (id: string) => Promise<any>,
  setIsDownloading?: (downloading: boolean) => void
) => {
  setIsDownloading?.(true);
  try {
    const fileResponse = await getFileUrl(attachmentId);
    const downloadUrl = fileResponse?.accessUrl || fileResponse?.url || fileResponse;
    const fileName = fileResponse?.fileName;

    if (downloadUrl) {
      if (fileName) {
        try {
          const response = await fetch(downloadUrl);
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          return;
        } catch (e) {
          console.warn("Failed to download with custom filename", e);
        }
      }
      window.open(downloadUrl, "_blank");
    }
  } catch (error) {
    console.error("Failed to download attachment", error);
  } finally {
    setIsDownloading?.(false);
  }
};
export const handleDownload = async (
  attachmentId: string,
  setIsDownloading?: (downloading: boolean) => void
) => {
  if (!attachmentId) return;
  await handleDownloadAttachment(attachmentId, globalApi.getCloudAttachment, setIsDownloading);
};
/**
 * Helper function to add timezone to date string
 * @param dateStr - Date string in format 'YYYY-MM-DD' or 'YYYY-MM-DDTHH:mm:ss'
 * @returns Date string with timezone offset
 */
export const getDateWithTimezone = (dateStr: string): string => {
  if (!dateStr) return dateStr;
  if (dateStr.includes("T") && (dateStr.includes("+") || dateStr.includes("Z"))) return dateStr;
  let base = dateStr;
  if (!dateStr.includes("T")) base += "T00:00:00";
  const offset = new Date().getTimezoneOffset();
  const absOffset = Math.abs(offset);
  const hours = String(Math.floor(absOffset / 60)).padStart(2, "0");
  const minutes = String(absOffset % 60).padStart(2, "0");
  const sign = offset <= 0 ? "+" : "-";
  return `${base}${sign}${hours}:${minutes}`;
};
